import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BookingsTableBodyBase } from './BookingsTableBody'

import { isLoadingSelector } from 'reduxModules/selectors/BookingSelectors'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { routeIdSelector, isFromUaRouteSelector } from 'reduxModules/selectors/RouteSelectors'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  routeId: routeIdSelector,
  isLoading: isLoadingSelector,
  isFromUaRoute: isFromUaRouteSelector,
})

export const BookingsTableBody = connect(mapStateToProps)(BookingsTableBodyBase)


// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableBody/index.js